export default {"src":"/_next/static/media/deco_calendar_glow.c7e2e8c1.svg","height":468,"width":468,"blurWidth":0,"blurHeight":0};